// components/CDKey/GameList.vue
<template>
  <div class="game-list">
    <div v-for="game in games" :key="game.id" class="game-card" @click="selectGame(game)">
      <img :src="game.image" :alt="game.title" class="game-image">
      <div class="game-info">
        <h3>{{ game.title }}</h3>
        <div class="game-stats">
          <span v-if="game.drops">{{ game.drops }} Drops</span>
          <span v-if="game.rewards">{{ game.rewards }} Rewards</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameList',
  data() {
    return {
      games: [
        {
          id: 1,
          title: 'PUBG: BATTLEGROUNDS',
          image: '/cdk/pubg.png',
          drops: 11,
          rewards: 33,
          type: 'pubg'
        },
        {
          id: 2,
          title: 'Party Animals',
          image: '/cdk/party-animals.jpg',
          drops: 1,
          rewards: 1,
          type: 'party-animals'
        },
        {
          id: 3,
          title: "Rust",
          image: '/cdk/rust.jpg',
          drops: 2,
          rewards: 5,
          type: 'rust'
        },
        {
          id: 4,
          title: "Rainbow Six Siege",
          image: '/cdk/rainbow-six-siege.jpg',
          drops: 2,
          rewards: 5,
          type: 'r6'
        },
        {
          id: 5,
          title: "Hunt: Showdown",
          image: '/cdk/hunt-showdown.jpg',
          type: 'hunt'
        }
      ]
    }
  },
  methods: {
    selectGame(game) {
      this.$router.push(`/cdkey/${game.type}`)
    }
  }
}
</script>

<style scoped>
.game-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.game-card {
  background-color: #24273a;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
}

.game-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.game-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.game-info {
  padding: 16px;
}

.game-info h3 {
  color: #ffffff;
  margin: 0 0 8px 0;
  font-size: 16px;
}

.game-stats {
  display: flex;
  gap: 16px;
  color: #9ca3af;
  font-size: 14px;
}
</style>

